import React from 'react';
import { EditParentAdminController } from 'src/components/enterprise/Parents/Admin/EditParentAdminController/EditParentAdminController';
import { useCanAccessParentAdminFlows } from './hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const EditParentAdmin: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <EditParentAdminController />;
};
